export enum EEventCategory {
  Meeting = 'meeting',
  OpenSession = 'open_session',
}

export enum EEventState {
  Pending = 'pending',
  InProgress = 'in_progress',
  Completed = 'completed',
}

export interface IMeetingSession {
  id: number;
  summary: string;
  url: string;
  category: EEventCategory;
  start: string;
  end: string;
}

export interface ICorrection {
  id: number;
  summary: string;
  url: string;
  state: EEventState;
  start: string;
  end: string;
}
